<!--锂电池数据 -->
<template>
  <div id="charges" style="background: #fff;">

    <!-- 搜索 -->
    <div id="search" class="filter-container" style="padding-left:20px;">
      <el-input v-model="listQuery.sn" clearable placeholder="sn" class="input-with-select deviceNameTable"
        @clear="searchTable">
        <el-button slot="append" icon="el-icon-search" @click="searchTable" />
      </el-input>
      <div style="float: right;margin: 13px 20px 0;">
        <el-button class="filter-item" type="primary" icon="el-icon-upload2" style="margin-top: -2px;margin-bottom: 0;"
          @click="uploadVersion" />
      </div>
    </div>

    <!-- 分页表格 -->
    <div class="app-container" style="padding-top:0;">
      <el-table id="chargesTable" v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit
        highlight-current-row>

        <el-table-column :label="$t('lithiumQr.sn')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sn }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.bmsModule')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bmsModule }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('lithiumQr.bmsPcbCode')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bmsPcbCode }}</span>
          </template>
        </el-table-column> 
        <el-table-column :label="$t('lithiumQr.bmsFirmwareVersion')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bmsFirmwareVersion }}</span>
          </template>
        </el-table-column>-->
        <el-table-column :label="$t('lithiumQr.batterySerialNumber')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batterySerialNumber }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('lithiumQr.batteryModule')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryModule }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.batteryBrand')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryBrand }}</span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('lithiumQr.voltage')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.voltage }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.batteryCapacity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryCapacity }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.bmsWeight')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bmsWeight }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.bmsSize')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bmsSize }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('lithiumQr.auth')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.auth }}</span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('lithiumQr.batteryMakeDate')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryMakeDate == null || scope.row.batteryMakeDate == 0 ? null : formatTime(scope.row.batteryMakeDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.bmsInstallDate')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bmsInstallDate == null || scope.row.bmsInstallDate == 0 ? null : formatTime(scope.row.bmsInstallDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.updateTime')" align="center">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.updateTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lithiumQr.updateBy')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.updateBy }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('yhubReport.Operating')" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native.prevent="edit(scope.row)">
              {{ $t('adminView.Edit') }}
            </el-button>

            <!-- 二维码连接 -->
            <el-button title="二维码连接" type="text" icon="el-icon-view" size="small" @click="viewUrl(scope.row)"> </el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination background current-page.sync="listQuery.pageInfo.page" :page-sizes="listQuery.pageInfo.pageList"
          :page-size="listQuery.pageInfo.limit" layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.pageInfo.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>

      <!-- 上传--弹窗 -->
      <el-dialog :close-on-click-modal="false" :visible.sync="uploadFileDialog">
        <el-form label-position="left" label-width="130px" style="width: 400px; margin-left:50px;">
          <el-form-item label="File Name">
            <el-upload ref="upload" class="upload-demo" action="" :on-change="handleChange" :file-list="fileList"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary"
                :loading="uploading">{{ $t('QR.SelectFile') }}</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('QR.ForExample')">
            03006722.xlsx
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="uploadFileDialog = false">{{ $t('button.Cancel') }}</el-button>
          <el-button type="primary" :disabled="fileList.length==0"
            @click="uploadFileSubmit">{{ $t('button.Submit') }}</el-button>
        </div>
      </el-dialog>

      <!-- 编辑--弹窗 -->
      <div>
        <el-dialog :close-on-click-modal="false" :title=" $t('adminView.Edit')" :visible.sync="editFormDialog"
          width="80%">
          <el-form ref="dataForm" :inline="true" :model="dataModel" label-width="200px"
            class="demo-form-inline editPop">
            <el-form-item :label="$t('lithiumQr.sn')">
              <el-input v-model="dataModel.sn" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.bmsModule')">
              <el-input v-model="dataModel.bmsModule" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.bmsPcbCode')">
              <el-input v-model="dataModel.bmsPcbCode" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.bmsFirmwareVersion')">
              <el-input v-model="dataModel.bmsFirmwareVersion" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.batterySerialNumber')">
              <el-input v-model="dataModel.batterySerialNumber" />
            </el-form-item>

            <el-form-item :label="$t('lithiumQr.batteryModule')">
              <el-input v-model="dataModel.batteryModule" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.batteryBrand')">
              <el-input v-model="dataModel.batteryBrand" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.batteryCapacity')">
              <el-input v-model="dataModel.batteryCapacity" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.batteryMakeDate')">
              <el-date-picker v-model="dataModel.batteryMakeDate" type="date"
                :placeholder="$t('location.pleaseSelectDate')" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.bmsInstallDate')">
              <el-date-picker v-model="dataModel.bmsInstallDate" type="date"
                :placeholder="$t('location.pleaseSelectDate')" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.bmsWeight')">
              <el-input v-model="dataModel.bmsWeight" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.bmsSize')">
              <el-input v-model="dataModel.bmsSize" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.auth')">
              <el-input v-model="dataModel.auth" />
            </el-form-item>

            <el-form-item :label="$t('lithiumQr.voltage')">
              <el-input v-model="dataModel.voltage" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.cycles')">
              <el-input v-model="dataModel.cycles" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.ratedEnergy')">
              <el-input v-model="dataModel.ratedEnergy" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.selfDischargeRate')">
              <el-input v-model="dataModel.selfDischargeRate" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.chargingMethod')">
              <!-- <el-input v-model="dataModel.chargingMethod" /> -->
              <el-select v-model="dataModel.chargingMethod" class="filter-item" clearable
                :placeholder="$t('button.select')">
                <el-option v-for="item in chargingMethodList" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.dischargeMethod')">
              <!-- <el-input v-model="dataModel.dischargeMethod" /> -->
              <el-select v-model="dataModel.dischargeMethod" class="filter-item" clearable
                :placeholder="$t('button.select')">
                <el-option v-for="item in dischargeMethodList" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.chargeDischargePort')">
              <!-- <el-input v-model="dataModel.chargeDischargePort" /> -->
              <el-select v-model="dataModel.chargeDischargePort" class="filter-item" clearable
                :placeholder="$t('button.select')">
                <el-option v-for="item in chargeDischargePortList" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.communicationPort')">
              <!-- <el-input v-model="dataModel.communicationPort" /> -->
              <el-select v-model="dataModel.communicationPort" class="filter-item" clearable
                :placeholder="$t('button.select')">
                <el-option v-for="item in communicationPortList" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.coolingMethod')">
              <!-- <el-input v-model="dataModel.coolingMethod" /> -->
              <el-select v-model="dataModel.coolingMethod" class="filter-item" clearable
                :placeholder="$t('button.select')">
                <el-option v-for="item in coolingMethodList" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.storageTemperature')">
              <el-input v-model="dataModel.storageTemperature" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.storageHumidity')">
              <el-input v-model="dataModel.storageHumidity" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.chargeWorkingTemperature')">
              <el-input v-model="dataModel.chargeWorkingTemperature" />
            </el-form-item>
            <el-form-item :label="$t('lithiumQr.dischargeWorkingTemperature')">
              <el-input v-model="dataModel.dischargeWorkingTemperature" />
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editFormDialog = false">{{ $t('button.Cancel') }}</el-button>
            <el-button type="primary" @click="submitForm">{{ $t('button.Submit') }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { pageList, importExcel, getQrCodeData, updateDeviceQrData } from '@/api/lithiumQR'
import { pagination } from '@/utils/init_table'
import { timeStamp2String } from '@/utils/index'
import i18n from '@/i18n'

export default {
  filters: {
    statusFilter (status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data () {
    return {
      list: null,
      listLoading: true,
      listQuery: {
        chargerSn: null,
        pageInfo: pagination()
      },

      chargingMethodList: [{ label: i18n.t('lithiumQr.chargingMethod1'), value: '1' }, { label: '2 ' + i18n.t('lithiumQr.otherVal'), value: '2' }],
      dischargeMethodList: [{ label: i18n.t('lithiumQr.dischargeMethod1'), value: '1' }, { label: '2 ' + i18n.t('lithiumQr.otherVal'), value: '2' }],
      chargeDischargePortList: [{ label: i18n.t('lithiumQr.chargeDischargePort1'), value: '1' }, { label: i18n.t('lithiumQr.chargeDischargePort2'), value: '2' }],
      communicationPortList: [{ label: '1 RS232', value: '1' }, { label: '2 RS485', value: '2' }, { label: '3 Bluetooth', value: '3' }, { label: '4 CAN', value: '4' }],
      coolingMethodList: [{ label: i18n.t('lithiumQr.coolingMethod1'), value: '1' }, { label: '2 ' + i18n.t('lithiumQr.otherVal'), value: '2' }],

      dialogStatus: '',
      dataModel: {
        sn: null,
        bmsModule: null,
        bmsPcbCode: null,
        bmsFirmwareVersion: null,
        batterySerialNumber: null,
        batteryModule: null,
        batteryBrand: null,
        batteryCapacity: null,
        batteryMakeDate: null,
        bmsInstallDate: null,
        bmsWeight: null,
        bmsSize: null,
        auth: null,

        voltage: null,
        cycles: null,
        ratedEnergy: null,
        selfDischargeRate: null,
        chargingMethod: null,
        dischargeMethod: null,
        chargeDischargePort: null,
        communicationPort: null,
        coolingMethod: null,
        storageTemperature: null,
        storageHumidity: null,
        chargeWorkingTemperature: null,
        dischargeWorkingTemperature: null,

        updateTime: null,
        updateBy: null,
        id: null
      },
      editFormDialog: false,
      fileList: [],
      uploadFileDialog: false,
      uploading: false,
      value: 8,
      tt: this.$i18n.locale
    }
  },
  created () {
    this.queryList()
  },
  watch: {
    '$i18n.locale' (val) {
      if (this.tt != val) {
        this.$router.go(0)
      }
    }
  },
  methods: {
    viewUrl (row) {
      open(`http://www.scanmi.net/d/05/?sn=${row.sn}&m=${row.bmsModule}`)
    },
    queryList () {
      this.listLoading = true
      // console.log(this.listQuery)
      var param = {
        companyIdList: [],
        sn: this.listQuery.sn,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      pageList(param).then(response => {
        this.list = response.resultModel.list
        this.list.forEach(v => {
          v.chargingMethod = (v.chargingMethod == null ? null : this.chargingMethodList[v.chargingMethod - 1].label)
          v.dischargeMethod = (v.dischargeMethod == null ? null : this.chargingMethodList[v.dischargeMethod - 1].label)
          v.chargeDischargePort = (v.chargeDischargePort == null ? null : this.chargeDischargePortList[v.chargeDischargePort - 1].label)
          v.communicationPort = (v.communicationPort == null ? null : this.communicationPortList[v.communicationPort - 1].label)
          v.coolingMethod = (v.coolingMethod == null ? null : this.coolingMethodList[v.coolingMethod - 1].label)
        })
        this.listQuery.pageInfo.total = response.resultModel.total
        this.listLoading = false
      })
    },
    uploadVersion () { // 上传
      this.uploadFileDialog = true
    },
    handleChange (file, fileList) { // 上传弹窗
      this.fileList.push(file)
      this.$refs.upload.clearFiles()
    },
    uploadFileSubmit () { // 上传文件弹窗--提交
      this.uploading = true
      var file = this.fileList.pop()
      // console.log('file--', file)
      importExcel(file, this.value).then(response => {
        if (response.resultCode == 1001) {
          this.uploadFileDialog = false
          // this.list = response.list
          this.$notify({
            title: '',
            message: i18n.t('lease.Succeed'),
            type: 'success',
            duration: 2000
          })
          this.queryList()
          this.uploading = false
        } else {
          var msg = i18n.t('lease.Failed')
          if (response.resultMessage.indexOf('解析错误') > -1) {
            msg = i18n.t('QR.contentError')
          }
          this.$notify({
            title: '',
            message: msg,
            type: 'error',
            duration: 2000
          })
          this.uploading = false
        }
      })
    },
    searchTable () {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    handleSizeChange (val, e) {
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) {
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    selectChange (selection) {
      this.itemIds = selection
    },
    submitForm () {
      var submitForm = JSON.parse(JSON.stringify(this.dataModel));
      submitForm.batteryMakeDate = new Date(submitForm.batteryMakeDate).getTime()
      submitForm.bmsInstallDate = new Date(submitForm.bmsInstallDate).getTime()

      submitForm.chargingMethod = (submitForm.chargingMethod == null ? null : submitForm.chargingMethod.substr(0, 1))
      submitForm.dischargeMethod = (submitForm.dischargeMethod == null ? null : submitForm.dischargeMethod.substr(0, 1))
      submitForm.chargeDischargePort = (submitForm.chargeDischargePort == null ? null : submitForm.chargeDischargePort.substr(0, 1))
      submitForm.communicationPort = (submitForm.communicationPort == null ? null : submitForm.communicationPort.substr(0, 1))
      submitForm.coolingMethod = (submitForm.coolingMethod == null ? null : submitForm.coolingMethod.substr(0, 1))

      updateDeviceQrData(submitForm).then(response => {
        if (response.resultCode != 1001) {
          this.$notify({
            title: '',
            message: "失败",
            type: 'error',
            duration: 2000
          })
          return
        }
        this.editFormDialog = false
        this.queryList()
        this.$notify({
          title: '',
          message: i18n.t('lease.Succeed'),
          type: 'success',
          duration: 2000
        })
      })
    },

    formatTime (s) {
      if (s == null) {
        return null
      }
      return timeStamp2String(s)
    },
    edit (data) {
      for (var key in data) {
        this.dataModel[key] = data[key]
      }
      this.editFormDialog = true
    },
    regionSelect (query) {
      for (const key2 in this.regionsOption) {
        const region = this.options[key2]
        console.log(region)
      }
    }
  }
}
</script>
<style lang="scss">
#chargesTable {
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  .el-table__expand-column {
    border-right: none;
  }
}
#bindCompany {
  .el-input {
    width: 80%;
  }
  .el-select {
    width: 100%;
  }
}
#charges {
  #search .el-input-group {
    width: 40% !important;
    max-width: 300px !important;
    margin-top: 13px;
  }
}
.editPop {
  .el-form-item--medium .el-form-item__content {
    width: 240px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>